enum ModalStateEnum {
    Closed = 'CLOSED',
    Off = 'OFF',
    Open = 'OPEN',
}

export default ModalStateEnum;